import type { Feature, FeatureGroup, FeatureModule } from '../../types';
import { PAYMENTS_FEATURE_GROUP } from './group';
import { PAYMENTS_TRANSACTIONS_MODULE } from './transactions';
import { PAYMENTS_GATEWAYS_MODULE } from './gateways';
import { PAYMENTS_TAKE_PAYMENT_MODULE } from './take-payment';
import { PAYMENTS_INTEGRATIONS_MODULE } from './integrations';
import { PAYMENTS_SETTINGS_MODULE } from './settings';
import { PAYMENTS_ACTIVITY_MODULE } from './activity';
import { PAYMENTS_DASHBOARD_MODULE } from './dashboard';

export { PAYMENTS_FEATURE_GROUP } from './group';
export * from './transactions';
export * from './gateways';
export * from './take-payment';
export * from './integrations';
export * from './settings';
export * from './activity';
export * from './dashboard';

export const ALL_PAYMENTS_MODULES: FeatureModule[] = [
  PAYMENTS_TRANSACTIONS_MODULE,
  PAYMENTS_GATEWAYS_MODULE,
  PAYMENTS_TAKE_PAYMENT_MODULE,
  PAYMENTS_INTEGRATIONS_MODULE,
  PAYMENTS_SETTINGS_MODULE,
  PAYMENTS_ACTIVITY_MODULE,
  PAYMENTS_DASHBOARD_MODULE,
];

export const ALL_PAYMENTS_FEATURE_GROUPS: FeatureGroup[] = [
  PAYMENTS_FEATURE_GROUP,
  ...ALL_PAYMENTS_MODULES.flatMap((m) => m.groups),
];

export const ALL_PAYMENTS_FEATURES: Feature[] = ALL_PAYMENTS_MODULES.flatMap((m) => m.features);
